import React from "react";
import { Box, Paper } from "@mui/material";
import AdminSidebar from "../AdminSidebar";

export default function SettingsLayout({ children }) {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", background: "#f7f7fa" }}>
      <AdminSidebar />
      <Box sx={{ flex: 1, p: 3, mt: 7, mb: 3 }}>
        <Paper sx={{ p: 3 }}>
          <Box mb={2}>
            {/* <a href="/admin/settings/google-calendar" style={{ textDecoration: 'none', color: '#1976d2', fontWeight: 600 }}>Google Calendar Settings</a> */}
          </Box>
          {children}
        </Paper>
      </Box>
    </Box>
  );
}
